interface LoadingMessageProps {
  isLoading: boolean | null
}

const LoadingMessage = ({ isLoading }: LoadingMessageProps) => {
  return (
    <div className='panel-footer clearfix'>
      {isLoading === false && <div>All changes are saved.</div>}
      <div className={`saving ${isLoading ? '' : 'hide'}`}>
        <div className='insided-loader'><span /></div>
        <span>Saving changes</span>
      </div>
    </div>
  )
}

export default LoadingMessage
